import React from "react";
import { Newspaper, Sparkles } from "lucide-react";
import { SeoMeta, SiteFooter, SiteNavbar } from "../shared/site";
import "../index.css";

export default function Blog() {
  return (
    <div className="relative min-h-screen flex flex-col bg-transparent text-white font-jersey overflow-hidden">
      <SeoMeta
        title="Blog"
        description="HackSeller updates, guides and product information for private gaming tools."
        canonicalPath="/Blog"
      />
      <div className="relative z-10">
        <SiteNavbar />

        <section className="pt-28 px-4 md:px-8 lg:px-12 py-16 bg-purple-950/25 backdrop-blur-[2px] border-b border-purple-400/20 rounded-b-3xl shadow-[0_18px_60px_rgba(124,58,237,0.18)] text-center">
          <div className="max-w-5xl mx-auto">
            <div className="inline-flex items-center gap-3 rounded-lg border border-purple-400/25 bg-purple-500/10 px-4 py-2 text-purple-200 text-lg font-bold">
              <Newspaper size={22} />
              Blog
            </div>
            <h2 className="mt-5 text-4xl md:text-6xl font-extrabold text-white leading-tight">Blog</h2>
            <p className="mt-5 text-gray-200 text-xl md:text-2xl leading-relaxed max-w-3xl mx-auto">
              This section is currently being updated.
            </p>

            <div className="mt-10 rounded-lg border border-purple-400/20 bg-gray-950/55 p-6 md:p-8 text-left shadow-[0_16px_45px_rgba(124,58,237,0.16)]">
              <div className="flex items-start gap-4">
                <Sparkles className="text-purple-300 shrink-0 mt-1" size={28} />
                <div>
                  <h3 className="text-2xl md:text-3xl font-extrabold text-white">Articles coming later</h3>
                  <p className="mt-3 text-gray-200 text-xl leading-relaxed">
                    Updates, guides, and product information will appear here when the blog is ready.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SiteFooter />
      </div>
    </div>
  );
}
